import {
  getCardDataApi,
  getCardPinApi,
  CardDto,
  PinDto,
  putNewCardPinApi,
  putCardStatusAsStolenApi,
  putCardStatusAsLostApi,
  putCardStatusAsFrozenApi,
  putCardStatusAsActiveApi,
  putConfirmSetNewCardPinApi,
  CardCriteria,
  ConfirmCardPinUpdateVm,
  CardPinUpdateVm,
  getAllTransactionsApi,
  TransactionStatement,
  TransactionDto,
  getOldTransactionsAccessTokenApi,
  getLatestTransactionsApi
} from "@/services/cards";
import actions from "./actions";
import { ApiCallParams } from "@/services/baseService";
import configuration from "@/services/config";
import store from "@/store/index";

interface ConfirmationSmsCodePayload {
  CardGuid: string;
  DateFrom: string;
  DateTo: string;
  ConfirmationSmsCode: string;
}

export default {
  actions: {
    async [actions.FETCH_CARD_DATA](ctx?: any) {
      const cardData: CardDto | undefined = await getCardDataApi();
      if (cardData !== undefined) {
        ctx.commit("updateCardDataMutation", cardData);
      }
    },

    async [actions.FETCH_CARD_PIN](ctx?: any, params?: ApiCallParams<string>) {
      if (params !== undefined) {
        const pinDto: PinDto | undefined = await getCardPinApi(params);
        if (pinDto !== undefined) {
          ctx.commit("updateCardPinMutation", pinDto);
          ctx.commit("updateIsDisplayPinModaleActiveMutation", true);
        }
      }
    },

    async [actions.PUT_NEW_CARD_PIN](
      ctx?: any,
      params?: ApiCallParams<CardPinUpdateVm>
    ) {
      if (params !== undefined) {
        const response: boolean = await putNewCardPinApi(params);
        if (response) {
          ctx.commit("updateIsActiveConfirmSetNewPinModaleMutation", true);
        }
      }
    },

    async [actions.PUT_CONFIRM_CODE_TO_SET_NEW_CARD_PIN](
      ctx?: any,
      params?: ApiCallParams<ConfirmCardPinUpdateVm>
    ) {
      if (params !== undefined) {
        await putConfirmSetNewCardPinApi(params);
      }
    },

    async [actions.PUT_CARD_STATUS_AS_STOLEN](
      ctx?: any,
      params?: ApiCallParams<string>
    ) {
      if (params !== undefined) {
        await putCardStatusAsStolenApi(params);
        ctx.commit("updateIsReportCardStolenButtonLoadingMutation", false);
      }
    },

    async [actions.PUT_CARD_STATUS_AS_LOST](
      ctx?: any,
      params?: ApiCallParams<string>
    ) {
      if (params !== undefined) {
        await putCardStatusAsLostApi(params);
        ctx.commit("updateIsReportCardLostButtonLoadingMutation", false);
      }
    },

    async [actions.PUT_CARD_STATUS_AS_FROZEN](
      ctx?: any,
      params?: ApiCallParams<string>
    ) {
      if (params !== undefined) {
        await putCardStatusAsFrozenApi(params);
        ctx.commit("updateIsFreezeCardButtonLoadingMutation", false);
      }
    },

    async [actions.PUT_CARD_STATUS_AS_ACTIVE](
      ctx?: any,
      params?: ApiCallParams<string>
    ) {
      if (params !== undefined) {
        await putCardStatusAsActiveApi(params);
        ctx.commit("updateIsActivateCardButtonLoadingMutation", false);
      }
    },

    async [actions.FETCH_ALL_TRANSACTIONS](
      ctx?: any,
      params?: ApiCallParams<CardCriteria>
    ) {
      if (params !== undefined) {
        const response = await getAllTransactionsApi(params);

        if (response !== undefined) {
          ctx.commit("updateTransactionsStatementMutation", response);
          if (!response.requiredSmsCode) {
            ctx.commit("updateIsAllTransactionsGridLoadingMutation", false);
          }
        } else {
          ctx.commit("updateIsAllTransactionsGridLoadingMutation", false);
        }
      }
    },

    async [actions.POST_SMS_CODE_TO_GET_OLD_TRANSACTIONS_ACCESS_TOKEN](
      ctx?: any,
      params?: ConfirmationSmsCodePayload
    ) {
      if (params !== undefined) {
        const response = await getOldTransactionsAccessTokenApi(
          params.ConfirmationSmsCode
        );

        if (response !== undefined && response !== null) {
          window.sessionStorage.setItem(
            configuration.apiTransactionsAccessStorageKey,
            response.token
          );

          const fetchTransactionsCriteria = {
            CardGuid: params.CardGuid,
            DateFrom: params.DateFrom,
            DateTo: params.DateTo,
            Token: response.token
          };
          await store.dispatch(
            actions.FETCH_ALL_TRANSACTIONS,
            fetchTransactionsCriteria
          );
        }
        ctx.commit("updateIsAllTransactionsGridLoadingMutation", false);
      }
    },

    async [actions.FETCH_LATEST_TRANSACTIONS](ctx?: any) {
      const response = await getLatestTransactionsApi();

      if (response !== undefined) {
        ctx.commit("updateLatestTransactionsMutation", response);
      }

      ctx.commit("updateIsDashboardTransactionsGridLoadingMutation", false);
    }
  },
  mutations: {
    updateCardDataMutation(state?: any, cardData?: any) {
      state.cardData = cardData;
    },
    updateCardPinMutation(state?: any, pinDto?: any) {
      state.cardPin = pinDto.pin;
    },
    updateFreezeCardStatusMutation(state?: any, isCardFrozen?: boolean) {
      state.isCardFrozen = isCardFrozen;
    },
    updateTransactionsStatementMutation(
      state?: any,
      transactionStatement?: TransactionStatement
    ) {
      state.transactionStatement = transactionStatement;
    },
    updateIsRequiredSmsCodeMutation(state?: any, requiredSmsCode?: boolean) {
      state.transactionStatement.requiredSmsCode = requiredSmsCode;
    },
    updateDateFromMutation(state?: any, dateFrom?: string) {
      state.dateFrom = dateFrom;
    },
    updateDateToMutation(state?: any, dateTo?: string) {
      state.dateTo = dateTo;
    },
    updateLatestTransactionsMutation(
      state?: any,
      latestTransactions?: TransactionDto[]
    ) {
      state.latestTransactions = latestTransactions;
    }
  },
  state: {
    cardData: {} as CardDto,
    cardPin: "",
    isCardFrozen: false,
    transactionStatement: {} as TransactionStatement,
    dateFrom: null,
    dateTo: null,
    latestTransactions: [] as TransactionDto[]
  },
  getters: {
    getCardData(state?: any) {
      return state.cardData;
    }
  }
};
